import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getAdvancedFlowCount = {
  name: "getAdvancedFlowCount" as const,
  input: z.object({ schema: createEnum(SchemaType) }),
  output: z.object({ count: z.number() }),
};
